export enum Status {
    Created = 0,
    Approved = 8,
    Published = 16,
    InProgressPublication = 32,
    FailedPublication = 64,
    ApprobationRefused = 128,
    PublicationRefused = 256
}
